import { Injectable } from '@angular/core';
import { ApplicationInsights, ICustomProperties } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: environment.applicationInsightsKey,
      enableAutoRouteTracking: true, // option to log all route changes
    },
  });

  constructor() {
    this.appInsights.loadAppInsights();
  }

  setAuthenticatedUserContext(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }

  logEvent(name: string, properties?: ICustomProperties) {
    this.appInsights.trackEvent({ name }, properties);
  }

  logMetric(name: string, average: number, properties?: ICustomProperties) {
    this.appInsights.trackMetric({ name, average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception, severityLevel });
  }

  logTrace(message: string, properties?: ICustomProperties) {
    this.appInsights.trackTrace({ message }, properties);
  }
}
